import moment from 'moment';

export const checkValidity = (value, rules, elementType=null) => {

    let isValid = true;
    if (!rules){
        return isValid;
    }

    if (rules.required){
        if(elementType && (elementType === 'date' || elementType === 'time')){
            if(elementType === 'date') {
                isValid = moment(value).isValid() && isValid;
            } else if(elementType === 'time') {
                isValid = value !== '' ? moment(`12/12/22 ${value}`).isValid() : false && isValid;
            }
            
        } else {
            if (typeof(value) == 'number'){
                isValid = value !== null && isValid;
            } else if(typeof(value) == 'boolean'){
                isValid = value
            } else if(value) {
                isValid = value && value !== '' && value.trim() !== '' && isValid; //trim removes white space at beginning or end
            } else {
                isValid = false
            }
            
        }
    }

    if (rules.minLength) {
        isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
        isValid = value.length <= rules.maxLength && isValid;
    }

    if (rules.isEmail) {
        if(!rules.required && value === ''){
            isValid = true && isValid;
        } else {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }
    }
     
    if (rules.isNumeric) {
        if(!rules.required && (value === '' || value === undefined)){
            isValid = true && isValid;
        } else {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }
        
    }

    if (rules.isCurrency) {
        if(!rules.required && value === ''){
            isValid = true && isValid
        } else {
            const pattern = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
            isValid = pattern.test(value) && isValid;
        }
        
    }

    if (rules.cannotSelectNone) {
        isValid = (value == 0 ? false : true) && isValid;
    }

    if (rules.isDate) {
        if(!rules.required && value === null) {
            isValid = true && isValid
        } else {
            isValid = moment(value).isValid() && isValid;
        }
    }

    if (rules.isTime) {
        if(!rules.required && value === null) {
            isValid = true && isValid
        } else {
            isValid = moment(`12/12/22 ${value}`).isValid() && isValid;
        }
    }

    // the && makes sure that each validation that applies, is checked
    return isValid
}

export const validate = (formData, validationSchema) => {
    let isValid = true
    let errors = {}

    // loop through all fields in form
    Object.keys(formData).forEach(fieldKey => {
        const fieldValue = formData[fieldKey]
        if(fieldKey in validationSchema) {
            if(validationSchema[fieldKey].type === 'list') {

                let validList = fieldValue.map(listItem => {

                    // run through all fields to validate
                    let validationListItem = {}
                    Object.keys(validationSchema[fieldKey].fields).forEach(listItemFieldKey => {
                        const listItemField = listItem[listItemFieldKey]

                        const fieldIsValid = checkValidity(listItemField, validationSchema[fieldKey].fields[listItemFieldKey].validation, validationSchema[fieldKey].fields[listItemFieldKey].type)
                        isValid = fieldIsValid && isValid

                        if(!fieldIsValid) { 
                            validationListItem[listItemFieldKey] = fieldIsValid 
                        }
                        
                    })

                    return validationListItem;
                })

                errors[fieldKey] = validList
                
            } else {
                const fieldIsValid = checkValidity(fieldValue, validationSchema[fieldKey].validation, validationSchema[fieldKey].type)
                isValid = fieldIsValid && isValid
                if(!fieldIsValid) { errors[fieldKey] = fieldIsValid }
            }
            
        }
        
    })

    return { errors, isValid }
}